// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-advanced-criteria {
  display: inline-block;

  width: 100%;
  position: relative;

  text-align: left;
}

.screener-advanced-criteria-button {
  display: inline-flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  border: none;
  padding: 9px 12px 9px 16px;
  background-color: transparent;

  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  &.open {
    background-color: var(--color-brand);
  }
}

.screener-advanced-criteria-button-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.screener-advanced-criteria-label {
  font-size: 12px;
  line-height: 100%;
  font-weight: 400;
  color: #000000;

  &.open {
    color: #ffffff;
  }
}

.screener-advanced-criteria-count {
  box-sizing: border-box;
  padding: 0px 4px;
  min-height: 16px;

  border-radius: 20px;
  background-color: #000000;
  color: #ffffff;

  font-weight: 700;
  font-size: 11px;
  line-height: 100%;
  text-align: center;
  align-content: center;

  &.open {
    background-color: #ffffff;
    color: #121212;
  }
}

.screener-advanced-criteria-expand {
  path {
    fill: #1e1f2f;
  }

  &.open {
    transform: rotate(180deg);

    path {
      fill: #bdbdbd;
    }
  }
}

.screener-advanced-criteria-list {
  box-sizing: border-box;
  position: absolute;
  z-index: 10;

  display: flex;
  padding: 16px 8px;
  width: 700px;
  height: 677px;

  border: 1px solid #bdbdbd;
  box-shadow: 0px 4px 8px 0px #0000001a;

  background-color: #fff;
  outline: none;
  overflow: hidden;
}

.screener-advanced-criteria-select-options-container {
  box-sizing: border-box;
  width: 50%;

  padding-right: 16px;
  border-right: 1px solid #bdbdbd;

  overflow-y: auto;
}

.screener-advanced-criteria-details-container {
  box-sizing: border-box;
  width: 50%;

  padding-left: 16px;
}

.screener-advanced-criteria-popup-button {
  height: 40px;
  box-sizing: border-box !important;
  flex: 1;
  background-color: #ffffff !important;
  border: 1px solid var(--color-brand) !important;

  font-family: 'Arial', 'Helvetica', 'Sans-serif' !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  color: var(--color-brand) !important;
  box-shadow: none !important;
  text-transform: none !important;
  &:hover {
    background: var(--color-brand-hover2) !important;
  }
}

.screener-advanced-criteria-popup-button-get-results {
  background-color: var(--color-brand) !important;
  color: #ffffff !important;

  &:disabled {
    background-color: #bdbdbd !important;
    color: #ffffff !important;
    border: 2px solid #bdbdbd !important;
  }
  &:hover {
    background: var(--color-brand) !important;
    opacity: 0.8 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/Criteria/AdvancedCriteriaPopup/AdvancedCriteriaPopup.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;;EAErB,WAAW;EACX,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;;EAEnB,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;;EAE7B,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;;EAE1B;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;;EAEd;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;;EAEd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;;EAErB;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;;IAEzB;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;EAEX,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,aAAa;;EAEb,yBAAyB;EACzB,qCAAqC;;EAErC,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;;EAEV,mBAAmB;EACnB,+BAA+B;;EAE/B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;;EAEV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,OAAO;EACP,oCAAoC;EACpC,+CAA+C;;EAE/C,0DAA0D;EAC1D,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;EAC/B;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;;EAEzB;IACE,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;EACtC;EACA;IACE,yCAAyC;IACzC,uBAAuB;EACzB;AACF","sourcesContent":[".screener-advanced-criteria {\n  display: inline-block;\n\n  width: 100%;\n  position: relative;\n\n  text-align: left;\n}\n\n.screener-advanced-criteria-button {\n  display: inline-flex;\n  gap: 8px;\n  justify-content: space-between;\n  align-items: center;\n\n  width: 100%;\n  height: 32px;\n\n  border: none;\n  padding: 9px 12px 9px 16px;\n  background-color: transparent;\n\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n\n  &.open {\n    background-color: var(--color-brand);\n  }\n}\n\n.screener-advanced-criteria-button-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.screener-advanced-criteria-label {\n  font-size: 12px;\n  line-height: 100%;\n  font-weight: 400;\n  color: #000000;\n\n  &.open {\n    color: #ffffff;\n  }\n}\n\n.screener-advanced-criteria-count {\n  box-sizing: border-box;\n  padding: 0px 4px;\n  min-height: 16px;\n\n  border-radius: 20px;\n  background-color: #000000;\n  color: #ffffff;\n\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 100%;\n  text-align: center;\n  align-content: center;\n\n  &.open {\n    background-color: #ffffff;\n    color: #121212;\n  }\n}\n\n.screener-advanced-criteria-expand {\n  path {\n    fill: #1e1f2f;\n  }\n\n  &.open {\n    transform: rotate(180deg);\n\n    path {\n      fill: #bdbdbd;\n    }\n  }\n}\n\n.screener-advanced-criteria-list {\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 10;\n\n  display: flex;\n  padding: 16px 8px;\n  width: 700px;\n  height: 677px;\n\n  border: 1px solid #bdbdbd;\n  box-shadow: 0px 4px 8px 0px #0000001a;\n\n  background-color: #fff;\n  outline: none;\n  overflow: hidden;\n}\n\n.screener-advanced-criteria-select-options-container {\n  box-sizing: border-box;\n  width: 50%;\n\n  padding-right: 16px;\n  border-right: 1px solid #bdbdbd;\n\n  overflow-y: auto;\n}\n\n.screener-advanced-criteria-details-container {\n  box-sizing: border-box;\n  width: 50%;\n\n  padding-left: 16px;\n}\n\n.screener-advanced-criteria-popup-button {\n  height: 40px;\n  box-sizing: border-box !important;\n  flex: 1;\n  background-color: #ffffff !important;\n  border: 1px solid var(--color-brand) !important;\n\n  font-family: 'Arial', 'Helvetica', 'Sans-serif' !important;\n  font-weight: 700 !important;\n  font-size: 16px !important;\n  line-height: 24px !important;\n  color: var(--color-brand) !important;\n  box-shadow: none !important;\n  text-transform: none !important;\n  &:hover {\n    background: var(--color-brand-hover2) !important;\n  }\n}\n\n.screener-advanced-criteria-popup-button-get-results {\n  background-color: var(--color-brand) !important;\n  color: #ffffff !important;\n\n  &:disabled {\n    background-color: #bdbdbd !important;\n    color: #ffffff !important;\n    border: 2px solid #bdbdbd !important;\n  }\n  &:hover {\n    background: var(--color-brand) !important;\n    opacity: 0.8 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
